// extracted by mini-css-extract-plugin
export var columnList = "_dl-0";